import { Theme } from '@mui/material/styles';

export const createMenuStyles = (theme: Theme) => ({
  menuItem: {
    base: {
      color: theme.palette.common.black,
      borderBottom: `0.25rem solid transparent`,
      textDecoration: 'none',
      textTransform: 'none' as const,
      transition: 'border 0.2s ease, color 0.2s ease',
      ':hover,:focus,:focus-within': {
        color: theme.palette.brand.primary,
        borderImage: `${theme.palette.gradients.gradient1} 1`,
        textDecoration: 'none',
      },
    },
    button: {
      my: 0,
      px: 1,
      py: 1,
      borderRadius: 0,
      display: 'flex',
      gap: 1,
      justifyContent: 'flex-start',
      textTransform: 'none' as const,
      minHeight: 48, // Consistent height for all buttons
    },
    desktopTopLevel: {
      borderRadius: 0,
      px: 1,
      py: 0,
      gap: 0,
      mb: 0, // Explicitly remove bottom margin
      fontSize: theme.typography.small.fontSize,
      whiteSpace: 'nowrap' as const,
      '.mega-menu-item--expanded &': {
        color: theme.palette.brand.primary,
        borderImage: `${theme.palette.gradients.gradient1} 1`,
      },
    },
    desktopSubmenu: {
      px: 2,
      py: 1.5,
      minHeight: 40, // Slightly smaller for submenu items
      justifyContent: 'flex-start',
    },
    submenu: {
      '&.mega-menu-item--expanded': {
        color: theme.palette.brand.primary,
        borderImage: `${theme.palette.gradients.gradient1} 1`,
      },
    },
    active: {
      borderImage: `${theme.palette.gradients.gradient1} 1`,
    },
    activeSubmenu: {
      color: theme.palette.brand.secondary,
      '&:hover,&:focus': {
        color: theme.palette.brand.secondary,
        borderImage: 'none',
        cursor: 'default',
      },
    },
    listItem: {
      padding: 0, // Remove default ListItem padding
    },
  },
  dropdown: {
    paper: {
      backgroundColor: theme.palette.common.white,
      border: 'none',
      borderRadius: 2,
      boxShadow: theme.shadows[8],
      minWidth: 280,
      width: 'max-content',
      overflow: 'auto',
      transition: 'width 0.3s ease-in-out',
    },
    paperFirstLevel: {
      backgroundColor: theme.palette.common.white,
      border: 'none',
      borderRadius: 2,
      boxShadow: theme.shadows[8],
      minWidth: 280,
      width: 'max-content',
      overflow: 'hidden',
      transition: 'width 0.3s ease-in-out',
    },
  },
  mobileDrawer: {
    paper: {
      width: 320,
      boxSizing: 'border-box' as const,
      background: theme.palette.common.white,
      pt: 1,
    },
  },
  link: {
    display: 'flex',
    alignItems: 'center',
    textDecoration: 'none',
    color: 'inherit',
    ':hover,:focus': {
      textDecoration: 'none',
      color: 'inherit',
    },
  },
});

export const getMenuItemDepthStyles = (depth: number) => ({
  pl: depth * 2 + 2,
  minHeight: depth > 0 ? 36 : 48,
  fontSize: Math.max(14, 16 - depth * 1),
});

export const getArrowRotation = (isExpanded: boolean) => ({
  transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
  transition: 'transform 0.2s',
});
